"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNowTime = exports.adpterTimezon = void 0;
var _construct2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/construct.js"));
/*
获取当前时间
type='timestamp'(时间戳)/'date'(日期)/'dateTime'() / UTC时区
*/
var getNowTime = exports.getNowTime = function getNowTime(type) {
  var nowDate = new Date();
  return nowDate.toUTCString();
};
function strDate(date) {
  // const date = instantiate(Date, arguments);
  var len = date.getTime();
  var offset = date.getTimezoneOffset() * 60000;
  var utcTime = len + offset;
  var time = new Date(utcTime + 3600000 * 8);
  var d = time;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
}
var CloneDate = Date;
window.debugOffset = 0;
var adpterTimezon = exports.adpterTimezon = function adpterTimezon() {
  var bind = Function.bind;
  var unbind = bind.bind(bind);
  function instantiate(constructor, args) {
    return new (unbind(constructor, null).apply(null, args))();
  }
  Date = function (Date) {
    MyDate.prototype = Date.prototype;
    MyDate.UTC = Date.UTC;
    MyDate.prototype.toISOString = function () {
      return strDate(this);
    };
    MyDate.prototype.getUTCFullYear = function () {
      return getTimeToString(this).getFullYear();
    };
    MyDate.prototype.getUTCMilliseconds = function () {
      return getTimeToString(this).getMilliseconds();
    };
    MyDate.prototype.getUTCMonth = function () {
      return getTimeToString(this).getMonth();
    };
    MyDate.prototype.getUTCDate = function () {
      return getTimeToString(this).getDate();
    };
    MyDate.prototype.getUTCHours = function () {
      return getTimeToString(this).getHours();
    };
    MyDate.prototype.getUTCMinutes = function () {
      return getTimeToString(this).getMinutes();
    };
    MyDate.prototype.getUTCSeconds = function () {
      return getTimeToString(this).getSeconds();
    };
    return MyDate;
    function getTimeToString(d) {
      return new Date(d.getTime() - 8 * 60 * 60 * 1000);
    }
    function MyDate() {
      var date = (0, _construct2.default)(CloneDate, Array.prototype.slice.call(arguments));
      return arguments.length > 0 && typeof arguments[0] === 'string' && arguments[0].indexOf('T') > -1 ? getLocalTime(date) : date;
    }
    function getLocalTime(d) {
      var currZone = d.getTimezoneOffset() / 60;
      var zone = 8;
      var diffZone = zone + currZone;
      var result = new Date(d.getTime() + diffZone * 60 * 60 * 1000);
      return result;
    }
  }(Date);
};